module.exports = __webpack_public_path__ + "img/headshot-abrouwer.e4a83880.png";